// Example of how to use Sentry in middleware or a server-side function
export default function (req, res, next) {
  try {
    // Your logic here
  } catch (error) {
    // Capture the error using Sentry
    Sentry.captureException(error);
    next(error); // Pass the error to the next middleware or error handler
  }
}